// Copyright (C) 2022 TANNER AG

import React, { useEffect, useState } from "react";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import MuiAppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import {
    CodeItemContentRelatedCodes,
    CodeItemContentSection,
    CodeItemContentSectionCustomerBenefits,
    CodeItemContentSectionDescription, CodeItemContentSectionKeyFacts, CodeItemContentSectionUsageNotes
} from "../../../graphql";
import {useHashLink} from "../../../hooks/usehashscroll";
import {TocScroller} from "../../../lib/tocscroller";

type Props = {
    sections?: CodeItemContentSection; // should be an array
    backgroundColor?: string;
};

export const OFFSET = 100;


const CodeDetailContentNav: React.FC<Props> = ({ sections,backgroundColor }) => {
    const sectionValues = Object.values(sections ?? {}).filter(
        (item): item is (CodeItemContentSectionCustomerBenefits |  CodeItemContentSectionKeyFacts|CodeItemContentSectionDescription |CodeItemContentSectionUsageNotes|  CodeItemContentRelatedCodes) =>
            item !== "CodeItemContentSection"
    );
    const [value, setValue] = useState<string>();
    const navigate = useHashLink(OFFSET);
    const [isUserSelecting, setIsUserSelecting] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, []);
    useEffect(() => {
        if(!value && sections) setValue(`${sections?.customerBenefits?.no}`??"");
        if(value) setValue(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, sections]);

    useEffect(() => {
        if (!sectionValues?.length) return;

        const scroller = new TocScroller(window, {
            offset: OFFSET+20,
            items: sectionValues.map((section) => ({
                activator: `${section.no}`,
                elements: [`${section.no}`]
            })),
            onActivate: (item) => {
                if (!isUserSelecting) {
                    setValue(item.activator);
                }
            }
        });

        const handleScroll = () => {
            scroller.forceProcess(); // or scroller.process() if you don't want to force
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            // No destroy method needed
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sectionValues, isUserSelecting]);
    const handleTabClick = (no: string) => {
        setIsUserSelecting(true);
        setValue(no);
        navigate(no);
        setTimeout(() => setIsUserSelecting(false), 500); // 500ms debounce
    };

    return (
        <MuiAppBar
            position="sticky"
            elevation={0}
            sx={{
                top: 49,
                backgroundColor: backgroundColor?backgroundColor:"grey.50",
                color: "text.secondary",
                zIndex:1
            }}
        >
            <Container>
                <Toolbar disableGutters variant="dense">
                    <Tabs value={value} indicatorColor="secondary">
                        {sectionValues?.filter(section =>{
                            if(section.__typename=== "CodeItemContentSectionCustomerBenefits" ||section.__typename=== "CodeItemContentSectionKeyFacts" ||section.__typename=== "CodeItemContentSectionDescription" || section.__typename=== "CodeItemContentSectionUsageNotes"){
                                return section.content!=="";
                            }else if(section.__typename=== "CodeItemContentRelatedCodes"){
                                return section.items?.length !== 0;
                            }
                            return true;
                        }).map((item) => (
                            <Tab
                                key={item.no}
                                label={item.title}
                                value={`${item.no}`}
                                onClick={() => handleTabClick(`${item.no}`)}
                            />
                        ))}
                    </Tabs>
                </Toolbar>
            </Container>
        </MuiAppBar>
    );
};

export default CodeDetailContentNav;
